import { INVESTMENT_PROFILE_TYPE_INDIVIDUAL } from "@components/Domain"


const isIndividualInvestment = ({ profileType }) => {
  return profileType === INVESTMENT_PROFILE_TYPE_INDIVIDUAL
}

export default isIndividualInvestment
